import { User, userActions } from './User.slice';
import { Article, articleActions } from './Article.slice';

const actions = {
    user: userActions,
    article: articleActions,
};

type Entries = 'user' | 'article';

type Accumulator = {
    [key in Entries]: (User | Article)[];
};

/**
 * Add any data into corresponding entity stores
 */
export const genericActions = {
    addMany: (data: (User | Article)[]) => async (dispatch: any) => {
        const clusteredData = data.reduce((acc, d) => {
            if (d.type in acc) acc[d.type].push(d);
            else acc[d.type] = [d];
            return acc;
        }, {} as Accumulator);
        Object.entries(clusteredData).forEach(([type, data]) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            dispatch(actions[type as Entries].addMany(data));
        });
    },
};
export type GenericActionsType = typeof genericActions;
